<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <!-- <div class="container">
      <backtospeisekarte></backtospeisekarte>
    </div> -->
    <v-card>
      <v-card-title class="display-3">
        Sushi á la carte
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="desserts" :search="search">
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtospeisekarte from './Backtospeisekarte.vue';
export default {
  // components: { Backtospeisekarte },
  name: 'Sushi á la carte',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/sushimithintergrund.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis pro Stück', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 'C1',
          speise: 'Tamango Sushi (Eierstich)',
          allergene: '(A, F, N)',
          preis: '2,40 €',
        },
        {
          nummer: 'C2',
          speise: 'Sake Sushi (Lachs)',
          allergene: '(A, F, D, N)',
          preis: '2,40 €',
        },
        {
          nummer: 'C3',
          speise: 'Maguro Sushi (Thunfisch)',
          allergene: '(A, F, D, N)',
          preis: '2,80 €',
        },
        {
          nummer: 'C4',
          speise: 'Ebi Sushi (Garnelen)',
          allergene: '(A, F, R, N)',
          preis: '2,80 €',
        },
        {
          nummer: 'C7',
          speise: 'Kani Sushi (Krebsersatz)',
          allergene: '(A, B, F, N)',
          preis: '2,40 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
